import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ApplicationState } from '../_reducers/application.reducers';

const getAppFeatureState =
  createFeatureSelector<ApplicationState>('application');

export const getApplicationsLoading = createSelector(
  getAppFeatureState,
  (state: ApplicationState) => state?.isApplicationsLoading
);

export const getEmailsLoading = createSelector(
  getAppFeatureState,
  (state: ApplicationState) => state?.emailsLoading
);

export const getTemplatesloading = createSelector(
  getAppFeatureState,
  (state: ApplicationState) => state?.templatesLoading
);

export const getTimeZonesLoading = createSelector(
  getAppFeatureState,
  (state: ApplicationState) => state?.timeZoneDataLoading
);

export const getLanguagesLoading = createSelector(
  getAppFeatureState,
  (state: ApplicationState) => state.languagesDataLoading
);

export const getDocTemplatesLoading = createSelector(
  getAppFeatureState,
  (state: ApplicationState) => state?.templatesLoading
);

/**
 * Select applications by user
 */
export const getUserApplications = createSelector(
  getAppFeatureState,
  (state: ApplicationState) => state.applications
);

/**
 * Select applicationMetrics by application id
 */
export const getAppMetrics = createSelector(
  getAppFeatureState,
  (state: ApplicationState) => state.appMetrics
);

export const getAppName = createSelector(
  getAppFeatureState,
  (state: ApplicationState) => state?.appNames
);

/**
 * Select applicationData
 */
export const getApplicationData = createSelector(
  getAppFeatureState,
  (state: ApplicationState) => state?.applicationsData
);

/**
 * Select user emails
 */
export const getEmails = createSelector(
  getAppFeatureState,
  (state: ApplicationState) => state?.emails
);

export const getApplicationIpTrackingDatatable = createSelector(
  getAppFeatureState,
  (state: ApplicationState) => state?.ipTrackingDatatable
);

export const getApplicationById = createSelector(
  getAppFeatureState,
  (state: ApplicationState) => state?.applicationById
);

/**
 * Select operations
 */
export const getApplicationOperations = createSelector(
  getAppFeatureState,
  (state: ApplicationState) => state?.operations
);

export const lastUpdatedApplication = createSelector(
  getAppFeatureState,
  (state: ApplicationState) => state?.lastUpdatedApplicationId
);

export const getApplicationUsersDatatable = createSelector(
  getAppFeatureState,
  (state: ApplicationState) => state?.usersDatatable
);

/**
 * Select error
 */
export const getApplicationError = createSelector(
  getAppFeatureState,
  (state: ApplicationState) => state?.error
);

export const getApplicationCreateDomainError = createSelector(
  getAppFeatureState,
  (state: ApplicationState) => state?.createError
);

/**
 * Select templates
 */
export const getTemplates = createSelector(
  getAppFeatureState,
  (state: ApplicationState) => state?.templates
);

/**
 * Select single template
 */
export const getTemplate = createSelector(
  getAppFeatureState,
  (state: any) => state?.template
);

export const getDocTemplates = createSelector(
  getAppFeatureState,
  (state: ApplicationState) => state?.templates
);


export const getDomainStatus = createSelector(
  getAppFeatureState,
  (state: ApplicationState) => state?.domainStatus
);

export const getCreateDomainResponse = createSelector(
  getAppFeatureState,
  (state: ApplicationState) => state?.createSuccess
);

export const getTimeZones = createSelector(
  getAppFeatureState,
  (state: ApplicationState) => state?.timeZoneData
);
export const getLanguages = createSelector(
  getAppFeatureState,
  (state: ApplicationState) => state?.languagesData
);

export const getSubdomains = createSelector(
  getAppFeatureState,
  (state: ApplicationState) => (state as any)?.subdomains
);

export const getSubdomainsLoading = createSelector(
  getAppFeatureState,
  (state: ApplicationState) => (state as any)?.subdomainsLoading
);
